import React, { Component } from 'react';
import { Rail as ImportRail } from 'semantic-ui-react';
import excludeKeys from '../../../../utils/excludeKeys';

class Rail extends Component {
  render() {
    return (
      <ImportRail {...excludeKeys(this.props)}>
        { this.props.children }
      </ImportRail>
    );
  }
}

export default Rail;
